<template>
  <div style="border-top: solid 1px #dcdcdc;">
    <div class="main ">
      <el-row style="color: #fff" class="keeps">
        <el-col :xs="24" :sm="6" class="paddingTop-78">
          <div class="imageed">
            <div class="botas">
              
                <img src="../../assets/456.png" />
             
              <div class="colock">
                Beijing overseasTalents Association(BOTA) <br />
                北京海外高层次人才协会
              </div>
            </div>
            <div class="asscion" >
              北京海外高层次人才协会成立于2011年,由李彦宏先生担任协会首届理事长。协会致力于促进海外高层次人才的团结与发展,并与其携手共同成为支撑首都高质量发展的重要力量。
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="2" class="hidden-xs-only">
          <div style="opacity: 0; display: inline-block;"></div>
        </el-col>
        <el-col :xs="24" :sm="6" class="paddingTop-78" >
          <div class="imageeds">
            <div class="botas">
            
                <img
                  style="width: 86px; height: 78px; margin-top: -8px"
                  src="../../assets/beijing.png"
                />
            
              <div class="colocks">
                Beijing Hycore lnnovation co.,Ltd.
                 <br />
                北京海高创新科技服务有限公司
                
              </div>
            </div>
            <div class="asscionss">
              北京海外高层次人才协会成立于2011年,由李彦宏先生担任协会首届理事长。协会致力于促进海外高层次人才的团结与发展,并与其携手共同成为支撑首都高质量发展的重要力量。
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="2" class="hidden-xs-only">
          <div style="opacity: 0; display: inline-block;"></div>
        </el-col>
        <el-col :xs="24" :sm="8" class="paddingTop-78">
          <div class="imageedsss">
            <div>
              <img class="likes" src="../../assets/good.png" />
            </div>
            <div class="miss">
              <div class="binds">
                <p>关于我们</p>
                <p>版权</p>
                <p>与我们联系</p>
                <p>隐私安全</p>
              </div>

              <div class="bindss">
                <p>赛事和峰会</p>
                <p>管家服务</p>
                <p>商学院</p>
                <p>基金</p>
                <p>产业园</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="main ">
      <el-row style="color: #fff">
        <el-col :xs="24" :sm="24">
          <div class="seeks">
            <img src="../../assets/cns.png" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
  data() {
    return {};
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.paddingTop-78{
  padding-top: 78px;
}
.imageed {
  /* padding-top: 93px; */
  /* padding-left: 112px; */
}
.seeks {
  /* padding-top: 93px; */
  /* padding-left: 103px; */
  /* margin-top: -60px; */
  margin-bottom: 95px;
}
.imageeds {
  /* padding-top: 71px; */
  /* padding-left: 112px; */
  /* margin-left: 172px; */
}
.imageedsss {
  /* padding-top: 75px; */

  /* margin-left: 172px; */
}
.botas {
  display: flex;
}
.colock {
  color: #ffffff;
  /* width: 178px;
  height: 88px; */
  font-size: 16px;
  
  font-weight: 500;
  line-height: 22px;

  margin-left: 12px;
}
.colocks {
  color: #ffffff;
  /* width: 178px;
  height: 88px; */
  font-size: 14px;
  
  font-weight: 500;
  line-height: 22px;

  margin-left: 12px;
}
.asscion {
  /* width: 266px;
  height: 140px; */
  font-size: 14px;
  
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  margin-top: 45px;
}
.asscionss {
  /* width: 266px;
  height: 140px; */
  font-size: 14px;
  
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  margin-top: 37px;
}
.keeps {
  /* display: flex; */
}
.binds {
  color: #ffffff;
  /* width: 72px;
  height: 20px; */
  font-size: 14px;
  
  font-weight: 500;

  line-height: 33px;
}
.bindss {
  color: #ffffff;
  /* width: 70px;
  height: 20px; */
  font-size: 14px;
  
  font-weight: 500;
  margin-left: 65px;
  line-height: 36px;
}
.miss {
  display: flex;
  margin-top: 33px;
}
</style>